import { VonqAttributes } from 'api-clients/monolith';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

type ChannelType = VonqAttributes['channel_type'];

export function useChannelType(channelType: ChannelType) {
  const intl = useIntl();

  return useMemo(() => {
    switch (channelType) {
      case 'social_media':
        return intl.formatMessage({
          defaultMessage: 'Social',
          description: 'Social media channel type',
        });
      case 'community':
        return intl.formatMessage({
          defaultMessage: 'Community',
          description: 'Community channel type',
        });
      case 'publication':
        return intl.formatMessage({
          defaultMessage: 'Publication',
          description: 'Publication channel type',
        });
      case 'aggregator':
        return intl.formatMessage({
          defaultMessage: 'Aggregator',
          description: 'Aggregator channel type',
        });
      case 'service':
        return intl.formatMessage({
          defaultMessage: 'Service',
          description: 'Service channel type',
        });
      case 'product_bundle':
        return intl.formatMessage({
          defaultMessage: 'Bundle',
          description: 'Bundle channel type',
        });
      case 'job_board':
      default:
        return intl.formatMessage({
          defaultMessage: 'Job Board',
          description: 'Job board channel type',
        });
    }
  }, [intl, channelType]);
}
